import * as React from 'react';
import { Path } from 'react-native-svg';
import { IconBase } from './IconBase';
export const IconMinus = (props) => (React.createElement(IconBase, { viewBox: "0 0 12 2", ...props },
    React.createElement(Path, { d: "M1 1H11", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })));
//# sourceMappingURL=IconMinus.js.map